import { all, fork } from "redux-saga/effects";
import authWatcher from "./Sagas/loginSaga";
import projectWatcher from "./Sagas/projectSaga";
import projectDetailsSagas from "./Sagas/projectDetailsSaga";
import employeesSaga from "./Sagas/employeesSaga";
import clientsListSaga from "./Sagas/clientListSaga";
import clientDetailsSagas from "./Sagas/clientDetailsSaga";

import userRolesListSaga from "./Sagas/userRolesListSaga";
import userPermissionListSaga from "./Sagas/usePermissionListSaga";
import {
  forgotPasswordAuthSaga,
  forgotPasswordSaga,
  SetChangePasswordUser,
} from "./Sagas/forgotPasswordSaga";
import myTaskListSaga from "./Sagas/myTaskListSaga";
import weeklyTimesheetSaga from "./Sagas/weeklyTimesheetSaga";

import getAllEmployeeTaskSaga from "./Sagas/getAllEmployeeTaskSaga";
import empWeeklyTimesheetSaga from "./Sagas/getAllEmployeeTimesheetReducer";
import getEachWeekTimesheetSaga from "./Sagas/getEachWeekTimesheetSaga";
import { watchChangePassword } from "./Sagas/changePasswordSaga";
import invoiceWatcher from "./Sagas/invoiceSaga"; 
import uploadWatcher from "./Sagas/uploadSaga";

export default function* rootSaga() {
  yield all([
    fork(authWatcher),
    fork(projectWatcher),
    fork(projectDetailsSagas),
    fork(employeesSaga),
    fork(clientsListSaga),
    fork(clientDetailsSagas),
    fork(userRolesListSaga),
    fork(userPermissionListSaga),
    fork(forgotPasswordSaga),
    fork(forgotPasswordAuthSaga),
    fork(SetChangePasswordUser),
    fork(myTaskListSaga),
    fork(weeklyTimesheetSaga),
    fork(getAllEmployeeTaskSaga),
    fork(empWeeklyTimesheetSaga),
    fork(getEachWeekTimesheetSaga),
	fork(watchChangePassword),
    fork(invoiceWatcher), 
    fork(uploadWatcher),
  ]);
}
